import { RootState } from '../types/store-types';

export const selectBusiness = (state: RootState) => {
  return state.business.business;
};

export const selectPermission = (state: RootState) => {
  return state.business.permission;
};
